







































import { defineComponent } from "@vue/composition-api";
import {
  ContentFeedSearchResult,
  InputDiscoveryContentFeedSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { TabField } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import ConfirmSensitiveContent from "@/components/ConfirmSensitiveContent";
import ContentFeedView from "@/components/ContentFeedView";
import EmptyContent from "@/components/EmptyContent";
import PageTitle from "@/components/PageTitle";
import TabsHeader from "@/components/TabsHeader";
import DiscoverySelectTagsModal from "@/views/PageDiscover/components/DiscoverySelectTagsModal.vue";

export default defineComponent({
  name: "DiscoverView",
  components: {
    ConfirmSensitiveContent,
    DiscoverySelectTagsModal,
    ContentFeedView,
    TabsHeader,
    BasePage,
    BaseIcon,
    PageTitle,
    EmptyContent,
  },
  props: {
    onFeed: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    enableScroll: { type: Boolean, required: true },
    followedUsersId: { type: Object as () => Map<string, boolean>, required: true },
    contentFeedSearchResult: { type: Object as () => ContentFeedSearchResult | null },
  },
  setup() {
    const { authUser } = useAuthUser();
    return {
      authUser,
    };
  },
  data() {
    return {
      filterData: { tagIds: undefined, sensitiveContent: false } as Partial<InputDiscoveryContentFeedSearch>,
      showSelectTags: false,
      feedId: null as string | null,
      selectedTags: [] as string[],
    };
  },
  computed: {
    allowSearch(): boolean {
      return config.featureSearchBar;
    },
    allowThemes(): boolean {
      return config.featureTags;
    },
    tabs(): TabField[] {
      const list = [
        {
          name: "home",
          text: $t("Home"),
          to: { name: "home" },
        },
        {
          name: "discover",
          text: $t("Discover"),
          to: { name: "discover" },
        },
      ];
      return (this.authUser && list) || list.filter(i => i.name !== "home");
    },
    emptyDiscover(): boolean {
      return !this.loading && this.contentFeedSearchResult?.result.length === 0;
    },
  },
  watch: {
    onFeed: {
      handler(status: boolean) {
        if (!status && this.feedId) {
          this.feedId = null;
        }
      },
      immediate: true,
    },
    contentFeedSearchResult: {
      handler(newData: ContentFeedSearchResult | null, oldData: ContentFeedSearchResult | null) {
        if (!oldData && newData && this.feedId === null && this.onFeed) {
          this.feedId = newData.result.find(() => true)?.id ?? null;
        }
      },
      immediate: true,
    },
  },
  methods: {
    openFeed(feedId: string) {
      this.feedId = feedId;
      this.$router.push({ name: "discoverFeed" });
    },
    onConfirm(sensitive: boolean) {
      this.$set(this.filterData, "sensitiveContent", sensitive ? undefined : false);
      this.$emit("filter", this.filterData);
    },

    onTagsSelect(tags: string[], closeSelection: boolean = true) {
      this.showSelectTags = !closeSelection;
      this.selectedTags = tags;
      this.$set(this.filterData, "tagIds", tags.length > 0 ? tags : undefined);
      if (closeSelection) {
        this.$emit("filter", this.filterData);
      }
    },
  },
});
